import { render, staticRenderFns } from "./account-credits.vue?vue&type=template&id=3999f66f&scoped=true&"
import script from "./account-credits.vue?vue&type=script&lang=js&"
export * from "./account-credits.vue?vue&type=script&lang=js&"
import style0 from "./account-credits.vue?vue&type=style&index=0&id=3999f66f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3999f66f",
  null
  
)

export default component.exports